export default __webpack_public_path__ + "static/logo-c26e51da7f5dab3356b7b0899a418370.png";